var mymap = L.map("mapid", {
    scrollWheelZoom: false,
}).setView([-39.8119833, -73.209143], 15);

var icon = L.icon({
    iconUrl: "./../images/silos-de-collico/marker-icon-2x.png",
    shadowUrl: "",

    iconSize: [25, 41], // size of the icon
    shadowSize: [0, 0], // size of the shadow
    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
    shadowAnchor: [4, 62], // the same for the shadow
    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
});

var marker = L.marker([-39.8119833, -73.209143], { icon: icon })
    .addTo(mymap)
    .bindPopup("Silos de Collico")
    .openPopup();

L.tileLayer(
    "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw",
    {
        maxZoom: 18,
        attribution: "Baluart.cl",
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
    }
).addTo(mymap);
